<template>
  <SmartLinkItemComponent
    class="action-section"
    custom-tag="tr"
    :id="model.system.id"
    :component="!model.system.workflow"
  >
    <SmartLinkStandaloneElement
      custom-tag="td"
      class="title"
      :codename="typ.elements.title.codename"
    >
      <RichText :value="data.title" />
      <p v-if="data.date">
        {{ dateDisplay }}
      </p>
    </SmartLinkStandaloneElement>

    <SmartLinkStandaloneElement
      v-if="hasAnyStatus"
      custom-tag="td"
      class="status"
      :codename="typ.elements.status.codename"
    >
      <span
        v-if="data.status && data.status.codename != 'no_status'"
        :class="
          getStatusClass(
            firstOrDefault(model.elements.status.value),
            model.elements.date.value ? new Date(model.elements.date.value) : undefined
          )
        "
      >
        <span class="label-mobile">{{ $t('status') }}:</span>
        {{
          $t(
            getStatus(
              firstOrDefault(model.elements.status.value),
              model.elements.date.value ? new Date(model.elements.date.value) : undefined
            )
          )
        }}
      </span>
    </SmartLinkStandaloneElement>

    <SmartLinkStandaloneElement
      custom-tag="td"
      class="explanation"
      :codename="typ.elements.explanation.codename"
    >
      <span class="label-mobile">{{ $t('explanation') }}:</span>
      <RichText :value="model.elements.explanation.value" />
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script setup lang="ts">
import type { ActionItemModel } from '~/models'
import { firstOrDefault } from '~/utils/first-or-default'
import { formatDateStringWithTimezone, formatWithTimezone, isEmpty } from '~/utils/kontent-helper'
import { contentTypes } from '~/models'
import { getStatusClass } from '~/utils/action-util'
import { getStatus } from '~/utils/action-util'
const typ = contentTypes.action_item
const props = defineProps<{
  model: ActionItemModel
  hasAnyStatus: boolean
}>()

const data = {
  title: props.model.elements.title.value,
  date: props.model.elements.date.value || '',
  dateTimeZone: props.model.elements.date.displayTimeZone || '',
  explanation: props.model.elements.explanation.value,
  status: firstOrDefault(props.model.elements.status.value),
  dateDisplayOption: props.model.elements.dateDisplayOption.value[0]?.codename
}

const dateDisplay = computed(() => {
  switch (data.dateDisplayOption) {
    case contentTypes.action_section.elements.date_display_option.options.no_date.codename:
      return ''
    case contentTypes.action_section.elements.date_display_option.options.date.codename:
      return formatDateStringWithTimezone(data.date, data.dateTimeZone)
    case contentTypes.action_section.elements.date_display_option.options.date_and_time.codename:
      return formatWithTimezone(data.date, data.dateTimeZone)
    default:
      return formatDateStringWithTimezone(data.date, data.dateTimeZone)
  }
})
</script>
